import { render, staticRenderFns } from "./FormTypePicker.vue?vue&type=template&id=242fa565"
import script from "./FormTypePicker.vue?vue&type=script&lang=js"
export * from "./FormTypePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports